<template>
  <div class="textarea-wrapper">
    <div class="textarea-property textarea-empty">
      <div v-show="length === 0">{{ placeholder }}</div>
    </div>
      <div class="textarea-property textarea custom-scroll" contenteditable ref="textarea" @mouseleave="recodeRang"
           @input="calculateContentLength" @paste="paste($event)" @keydown.tab.prevent="inputTab">
      </div>
    <span class="limit" :style="length > limit ? {color: '#ff7044'} : {}">{{ length }} / {{ limit }}</span>
  </div>
</template>

<script>
    import {textConvertImg} from "../../js/utils/imgUtils";

    export default {
        name: "EditTextarea",
        props: {
            //未输入时显示内容
            placeholder: {
                type: String,
                default: "输入内容..."
            },
            //输入字数限制
            limit: {
                type: Number,
                default: 50
            }
        },
        data() {
            return {
                editFlag: false,
                content: "",
                //离焦时所选的范围
                range: null,
                length: 0,
            }
        },
        methods: {
            focus() {
                this.textarea.focus();
                //默认将光标移动到末尾
                if (document.selection) {
                    let sel = document.selection.createRange();
                    sel.moveStart('character', this.textarea.innerText.length);
                    sel.collapse();
                    sel.select();
                } else {
                    let sel = window.getSelection();
                    let range = document.createRange();
                    range.selectNodeContents(this.textarea);
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            },
            //记录光标位置
            recodeRang() {
                let textarea = this.$refs.textarea;
                //记录输入框离焦时光标的位置
                let sel = window.getSelection();
                if (textarea.contains(sel.anchorNode) && textarea.contains(sel.focusNode)) {
                    this.range = sel.getRangeAt(0) ? sel.getRangeAt(0) : null;
                }
            },
            analysisInnerText(e) {
                let text = "";
                for (let y = 0; y < e.childNodes.length; y++) {
                    let node = e.childNodes[y];
                    switch (node.nodeType) {
                        case 1: //如果是标签节点
                            if (node.localName === "div") {
                                if (y !== 0) {
                                    text += "\n";
                                }
                                if (node.childNodes.length > 1) {
                                    text += this.analysisInnerText(node);
                                } else {
                                    text += node.innerText;
                                }
                            } else if (node.localName === "br") {
                                text += "\n";
                            }
                            break;
                        case 3: //文本节点
                            text += node.data;
                            break
                    }
                }
                return text;
            },
            //获取textarea的内容，去空格换行并转义表情等
            getContent() {
                //克隆编辑区域
                let textarea = this.$refs.textarea.cloneNode(true);
                //getElementsByTagName返回的数组不继承Array，转换成Array
                let codeImages = Array.prototype.slice.call(textarea.getElementsByTagName("img"));
                for (let i = 0; i < codeImages.length; i++) {
                    let code = codeImages[i].getAttribute("code");
                    if (code) {
                        codeImages[i].parentElement.replaceChild(document.createTextNode(code), codeImages[i]);
                    }
                }
                let text = this.analysisInnerText(textarea);
                textarea.remove();
                return text;
            },
            //粘贴纯文本
            paste(e) {
                let text = '', event = (e.originalEvent || e);
                if (event.clipboardData && event.clipboardData.getData) {
                    text = event.clipboardData.getData('text/plain');
                } else if (window.clipboardData && window.clipboardData.getData) {
                    text = window.clipboardData.getData('Text');
                }
                if (document.queryCommandSupported('insertText')) {
                    document.execCommand('insertText', false, text);
                } else {
                    document.execCommand('paste', false, text);
                }
                e.preventDefault();

            },
            //清除输入内容
            clean() {
                this.$refs.textarea.innerHTML = "";
                this.length = 0;
            },
            textareaAddElement(e) {
                this.recodeRang();
                let textarea = this.$refs.textarea;
                let range = this.range;
                //判断是否有上次光标的位置
                if (!range) {
                    //没有，新建选区
                    range = document.createRange();
                    range.selectNodeContents(textarea);
                } else {
                    //有，删除选中内容
                    range.deleteContents();
                }
                //选区移动到末尾
                range.collapse(false);
                //插入元素
                range.insertNode(e);
                //选区移动到末尾
                range.collapse(false);
                this.range = range;
                //创建选中对象
                let sel = window.getSelection();
                sel.removeAllRanges();
                //添加选区
                sel.addRange(range);
                this.calculateContentLength();
            },
            //添加表情
            addFace({url, title, code}) {
                this.$nextTick(() => {
                    let img = document.createElement("img");
                    img.src = url;
                    img.alt = code;
                    img.title = title;
                    img.setAttribute("code", code);
                    img.setAttribute("class", "meta");
                    this.textareaAddElement(img);
                })
            },
            //添加@人员
            addAt({id, name}) {
                this.$nextTick(() => {
                    let e = document.createElement("img");
                    e.title = "@" + name;
                    e.alt = "@[" + id + "]";
                    e.src = textConvertImg("@" + name);
                    e.setAttribute("code", "@[" + id + "]");
                    e.setAttribute("class", "meta at");
                    this.textareaAddElement(e);
                })
            },
            //计算内容长度,表情、艾特占1位
            calculateContentLength(e) {
                let t = this.$refs["textarea"];
                this.length = t.innerText.length + t.getElementsByTagName("img").length;
            },
            //tab按键事件
            inputTab() {
                this.textareaAddElement(document.createTextNode("\u00a0\u00a0\u00a0\u00a0"));
            }
        },
        computed: {
            textarea() {
                return this.$refs.textarea;
            }
        }
    }
</script>
<style scoped>
  @import '../../css/space_common.css';

  .textarea-wrapper {
    position: relative;
  }

  .textarea-property {
    min-height: 72px;
    max-height: 120px;
    line-height: 22px;
    padding: 7px 10px 20px 10px;
    width: 100%;
  }

  .textarea-empty {
    color: #999;
    user-select: none;
    position: absolute;
  }

  .textarea {
    cursor: pointer;
    outline: none;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .04);
    overflow-y: auto;
    word-break: break-all;
    white-space: pre-wrap;
    position: relative;
  }

  /*css 穿透*/
  .textarea /deep/ .meta {
    margin: 0 2px;
    vertical-align: middle;
    font-size: 0;
  }

  /*css 穿透*/
  .textarea /deep/ .meta.at {
    border-radius: 4px;
  }

  .limit {
    font-size: 12px;
    position: absolute;
    right: 10px;
    bottom: 5px;
    z-index: 1;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/view/baseComponent/EditTextarea.vue